/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassificationTierTarget
 */
export interface ClassificationTierTarget {
    /**
     * 
     * @type {string}
     * @memberof ClassificationTierTarget
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    fromValue: number;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    toValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRetentionRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRateChange?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRateChangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRateChangeMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRateChangeAdjustment?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRateChangeRemaining?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationTierTarget
     */
    targetRetentionRateRemaining?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClassificationTierTarget
     */
    classificationTierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassificationTierTarget
     */
    classificationTierKey?: string | null;
}

/**
 * Check if a given object implements the ClassificationTierTarget interface.
 */
export function instanceOfClassificationTierTarget(value: object): value is ClassificationTierTarget {
    if (!('fromValue' in value) || value['fromValue'] === undefined) return false;
    return true;
}

export function ClassificationTierTargetFromJSON(json: any): ClassificationTierTarget {
    return ClassificationTierTargetFromJSONTyped(json, false);
}

export function ClassificationTierTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassificationTierTarget {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fromValue': json['fromValue'],
        'toValue': json['toValue'] == null ? undefined : json['toValue'],
        'targetRetentionRate': json['targetRetentionRate'] == null ? undefined : json['targetRetentionRate'],
        'targetRateChange': json['targetRateChange'] == null ? undefined : json['targetRateChange'],
        'targetRateChangeMin': json['targetRateChangeMin'] == null ? undefined : json['targetRateChangeMin'],
        'targetRateChangeMax': json['targetRateChangeMax'] == null ? undefined : json['targetRateChangeMax'],
        'targetRateChangeAdjustment': json['targetRateChangeAdjustment'] == null ? undefined : json['targetRateChangeAdjustment'],
        'targetRateChangeRemaining': json['targetRateChangeRemaining'] == null ? undefined : json['targetRateChangeRemaining'],
        'targetRetentionRateRemaining': json['targetRetentionRateRemaining'] == null ? undefined : json['targetRetentionRateRemaining'],
        'classificationTierId': json['classificationTierId'] == null ? undefined : json['classificationTierId'],
        'classificationTierKey': json['classificationTierKey'] == null ? undefined : json['classificationTierKey'],
    };
}

export function ClassificationTierTargetToJSON(json: any): ClassificationTierTarget {
    return ClassificationTierTargetToJSONTyped(json, false);
}

export function ClassificationTierTargetToJSONTyped(value?: ClassificationTierTarget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fromValue': value['fromValue'],
        'toValue': value['toValue'],
        'targetRetentionRate': value['targetRetentionRate'],
        'targetRateChange': value['targetRateChange'],
        'targetRateChangeMin': value['targetRateChangeMin'],
        'targetRateChangeMax': value['targetRateChangeMax'],
        'targetRateChangeAdjustment': value['targetRateChangeAdjustment'],
        'targetRateChangeRemaining': value['targetRateChangeRemaining'],
        'targetRetentionRateRemaining': value['targetRetentionRateRemaining'],
        'classificationTierId': value['classificationTierId'],
        'classificationTierKey': value['classificationTierKey'],
    };
}

